import { getUID } from '@redviking/argonaut-util/src/getUID';
import type { NodeSpec } from './NodeSpec';
import type { NodeCfg } from '@redviking/argonaut-util/types/mes/applet-designs/flow.latest';

export const strCastNodeSpec: NodeSpec<NodeCfg<'strCast'>> = {
    requiredSockets: 'all',
    cfg: () => ({ controlValues: {}, id: getUID(), kind: 'strCast', disabled: false }),
    controls: () => ({}),
    inputs: () => ({ input: { socket: 'anyData', label: 'Input' } }),
    kindLabel: 'String Value Cast',
    nodeCategory: 'text',
    outputs: () => ({ output: { socket: 'string', label: 'Output' } }),
    validator: () => true,
};
